import { render, staticRenderFns } from "./DialogCgEliteRequired.vue?vue&type=template&id=c1fae334&scoped=true"
import script from "./DialogCgEliteRequired.vue?vue&type=script&lang=js"
export * from "./DialogCgEliteRequired.vue?vue&type=script&lang=js"
import style0 from "./DialogCgEliteRequired.vue?vue&type=style&index=0&id=c1fae334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fae334",
  null
  
)

export default component.exports